/**
 * This modules creates a couple default sources.
 * The rwg.sources instance of this module is called to create new sources.
 * And new sources are created from the paramList of source definitions when instantiated.
 */

// import Vector from '../node_modules/ol/source/Vector.js';
import ImageWMS from '../node_modules/ol/source/ImageWMS.js'; // might go away: https://github.com/openlayers/openlayers/issues/15518#issuecomment-1915702726
import BingMaps from '../node_modules/ol/source/BingMaps.js';
import Google from '../node_modules/ol/source/Google.js'; // new 2024-01
// import Google from './Google.js'; // copied from ol/, should go away
import TileWMS from '../node_modules/ol/source/TileWMS.js';
import WMTS from '../node_modules/ol/source/WMTS.js'
import XYZ from '../node_modules/ol/source/XYZ.js';
import OSM from '../node_modules/ol/source/OSM.js';
import MVT from '../node_modules/ol/format/MVT.js';
import VectorTile from '../node_modules/ol/source/VectorTile.js';

import WMTSTileGrid from '../node_modules/ol/tilegrid/WMTS.js';
// import {get as getProjection} from 'ol/proj.js';
// import {getTopLeft, getWidth} from 'ol/extent.js';

// import {createLoader} from 'ol/source/wms';
// import TileGrid from 'ol/tilegrid/TileGrid' // req'd for non-epsg:3857 tiles
// import Attribution from '../node_modules/ol/control/Attribution.js';

// with import 722k; w/o import 533k  (189k!)
// #if process.env.WITH_GEOTIFF
// import GeoTIFF from '../node_modules/ol/source/GeoTIFF'; // new ol 6.7
// #endif

import SourceJSON from './SourceJSON.js';

function Sources(paramList) {
  this.list = {}
  // default source
  this.addVector('lyrDraw') // user drawn features
  // default source
  this.addImageWMS('mapservBase', {  // for single Image or ol.source.TileWMS() for tiled
    url: rwg.config.mapserv, // rwg.ms_map_url,
    ratio: 1.0,  // map request size relative to map viewport, default: 1.5
    params: {
      MAP: rwg.config.mapfile,
      // TRANSPARENT: true,  // makes JPEG nodata areas black, ugly! But necessary for GIF over a tile layer.
      // TRANSPARENT: rwg.layers.getImageType('lyrBase').includes('gif'),  // bool - this is in dlegendHandler.js also
      // want TRANSPARENT=true for png (at least in Clark County) which above doesn't do
      TRANSPARENT: !rwg.layers.getImageType('lyrBase').includes('jpeg'),  // bool - this is in dlegendHandler.js also
      LAYERS: rwg.layers.getActiveDrawLayers('lyrBase').toString(),
      // VERSION: '1.1.1',
      FORMAT: rwg.layers.getImageType('lyrBase')
    },
    // serverType: ('mapserver')
    // attributions: []
  })
  // additional sources may be added from paramList which is the "sources" object in conf.js
  if (paramList) {
    for (const source in paramList) {
      let type = paramList[source].type
      switch (type) {
        case 'ImageWMS':  // single Image  WMS
          this.addImageWMS(source, paramList[source])
          break
        case 'BingMaps':
        case 'Google':
        case 'TileWMS':
        case 'XYZ':
        case 'OSM':
          this.addTile(source, type, paramList[source])
          break
        case 'WMTS':  // this defaults to EPSG:3857, untested for other projections
          let options = paramList[source]
          options.matrixSet = options.matrixSet ? options.matrixSet : 'GoogleMapsCompatible' // req'd
          // Seems like size will always be 156543.03392804097 for epsg:3857 so
          // hard coding it eliminates 3 calculations below and these 2 imports:
          //    import {get as getProjection} from 'ol/proj.js';
          //    import {getTopLeft, getWidth} from 'ol/extent.js';
          // const projection = getProjection('EPSG:3857');
          // const projectionExtent = projection.getExtent();
          // const size = getWidth(projectionExtent) / 256;
          const size = 156543.03392804097 // hard coded for epsg:3857
          const zooms = 23
          const resolutions = new Array(zooms);
          const matrixIds = new Array(zooms);
          for (let z = 0; z < zooms; ++z) {
            // generate resolutions and matrixIds arrays for this WMTS
            resolutions[z] = size / Math.pow(2, z);
            matrixIds[z] = z;
          }
          options.wmtsTileGrid = options.wmtsTileGrid ? options.wmtsTileGrid : {}
          options.wmtsTileGrid.origin = options.wmtsTileGrid.origin ? options.wmtsTileGrid.origin : [-20037508.34278925, 20037508.34278925]
          options.wmtsTileGrid.resolutions = resolutions
          options.wmtsTileGrid.matrixIds = matrixIds
          options.tileGrid = new WMTSTileGrid(options.wmtsTileGrid)
          options.projection = options.projection ? options.projection: 'EPSG:3857'

          this.addTile(source, type, options)
          break
        case 'MVT':
          this.addMapboxVectorTile(source, paramList[source])
          break
        default: // GeoJSON or TopoJSON
          this.addVector(source, paramList[source])
      }
    }
  }
}

Sources.prototype.get = function(name) {
  return this.list[name];
};

Sources.prototype.addVector = function(name, params) {
  this.list[name] = new SourceJSON(params);
  return this.list[name];

  /* const vectSrc = new Vector(SourceJSON(params));
  if (params?.properties) {
    vectSrc.setProperties(params.properties);
  }
  this.list[name] = vectSrc;
  return vectSrc */
};

Sources.prototype.addImageWMS = function(name, args) {
  args = args || {}
  args.url = args.url || rwg.config.mapserv
  args.ratio = args.ratio || 1.0
  args.params = args.params || {}
  args.params.MAP = args.params.MAP || rwg.config.mapfile
  args.params.FORMAT = args.params.FORMAT || rwg.config.defaultImgTyp
  if (!args.params.LAYERS) {
    let layers = rwg.layers.getActiveDrawLayers(name).toString()
    if (layers) {
      args.params.LAYERS = layers
    }
  }
  this.list[name] = new ImageWMS(args)
  return this.list[name];
}

/* // 2024-01-31 possible start on replacement in case ol/source/ImageWMS goes away
Sources.prototype.addImageWMS = function(name, args) {
  args = args || {}

  args.url = args.url || rwg.config.mapserv
  args.ratio = args.ratio || 1.0
  args.params = args.params || {}
  args.params.MAP = args.params.MAP || rwg.config.mapfile
  args.params.FORMAT = args.params.FORMAT || rwg.config.defaultImgTyp
  if (!args.params.LAYERS) {
    let layers = rwg.layers.getActiveDrawLayers(name).toString()
    if (layers) {
      args.params.LAYERS = layers
    }
  }

  let loader = createLoader({
    // crossOrigin:
    // hidpi:
    params: args.params,
    // projection: ol Default is 'EPSG:3857'.
    ratio: args.ratio || 1.0, // request size relative to viewwport size, ol default: 1.5
    // serverType: mapserver, geoserver, carmentaserver, or qgis. Only needed if hidpi is true.
    url: args.url = args.url || rwg.config.mapserv,
    // load: Function to perform loading of the image. Receives the created HTMLImageElement and the desired src as argument and returns a promise resolving to the loaded or decoded image. Default is decode.
  })


  this.list[name] = new Image({
    // attributions	AttributionLike | undefined	Attributions.
    // interpolate	boolean (defaults to true)
    loader: loader,
    // projection	ProjectionLike | undefined	Projection.
    // resolutions	Array.<number> | undefined	Resolutions.
    // state	State | undefined	State.

  })
  return this.list[name];
}
*/



Sources.prototype.addTile = function(name, type, params) {
  const types = {
    'BingMaps': BingMaps,
    'Google': Google,
    'TileWMS': TileWMS,
    'WMTS': WMTS,
    'XYZ': XYZ,
    'OSM': OSM,
    // #if process.env.WITH_GEOTIFF
//     'GeoTIFF': GeoTIFF,
    // #endif
  }
  this.list[name] = new types[type](params)
  return this.list[name]
}

Sources.prototype.addMapboxVectorTile = function(name, params) {
  params.format = new MVT()
  // DANGER: projection must have already been created w/ new Projection(), which is not guaranteed
  params.projection = rwg.config.olView.projection
  /*
  if (params.tileGridOptions) { // for non-epsg:3857 coordinate systems
    params.tileGrid = new TileGrid(tileGridOptions)
  }
  */
  this.list[name] = new VectorTile(params)
}

/*
Sources.prototype.getEditable = function() {
  for (const sourceName in this.list) {
    if (this.list[sourceName].get('editable')) {
      return this.list[sourceName];
    }
  }
}

Sources.prototype.setEditable = function(sourceName) {
  console.warn('setEditable() should un-set any currently editable source!')
  this.list[sourceName]?.set('editable');
}
*/

export default Sources;
